import { render, staticRenderFns } from "./EntityTable.vue?vue&type=template&id=0a59f0b0"
import script from "./EntityTable.vue?vue&type=script&lang=ts"
export * from "./EntityTable.vue?vue&type=script&lang=ts"
import style0 from "./EntityTable.vue?vue&type=style&index=0&id=0a59f0b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports